/**
 * Basically this file contains single function
 * that only handles .in -class toggling to
 * car card when showing detailed info in car card
 */
export default function carCardInfoToggle() {
  // Add event listener only when there is car-cards in page
  if(document.getElementsByClassName('.car-card__more-info')) {
    document.body.addEventListener('click', (e) => {
      if(e.target.classList.contains('car-card__more-info')) {

        const specificDetails = e.target.parentNode.querySelector('.car-card__specific-wrapper'),
          carImage        = e.target.parentNode.querySelector('img');

        // Toggle in-classes
        specificDetails.classList.toggle('in');
        e.target.classList.toggle('in');

        if(specificDetails.classList.contains('in')) {
          carImage.style.maxHeight = (carImage.scrollHeight - specificDetails.scrollHeight) + 'px';
          specificDetails.style.height = specificDetails.scrollHeight + 'px';
        } else {
          carImage.style.maxHeight = '';
          specificDetails.style.height = '';
        }
      }
    })
  }
}
